@import 'styles/mixins';
@import 'styles/variables';

/* stylelint-disable-next-line css-modules/no-global-scoped-selector */
:root {
  --neruda-toolbar-bravo-height: 48px;
}

.container {
  @include focus-mode-transition;
  @include z-index(proseEditHeaderBar);
  @include transition;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  color: var(--neutral-50);
  position: relative;

  &.focusMode {
    opacity: 0;
  }

  .formatMenuWrapper .unlockAvatar {
    position: relative;
    align-items: center;
    top: 0;
    left: 6px;
    margin-right: 8px;
  }
}

.formatMenuWrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.toolbarButtons {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 16px;

  [data-design-system='blaze'] & {
    border-radius: 36px;
    background: rgba(255, 255, 255, 0.07);
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
    overflow: hidden;
    margin-left: 0;

    button {
      height: 40px;
    }
  }
}

.formatButtons {
  flex-grow: 1;
  justify-content: center;

  [data-design-system='blaze'] & {
    flex-grow: 0;
  }
}

.trackedChanges {
  color: var(--neutral-50);
}
